<template>
  <div class="ar-container" :style="finalContainerStyle">
    <div class="ar-inner" :class="{ 'ar-limit': finalContainerStyle }">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
/**
 * 指定宽高比的容器
 */
const props = withDefaults(
  defineProps<{
    value?: string | number
  }>(),
  {
    value: ''
  }
)

const finalContainerStyle = computed(() => {
  if (typeof props.value === 'number') {
    return `height: auto; min-height: auto; padding-top: ${100 / props.value}%`
  } else {
    return ''
  }
})
</script>

<style lang="scss" scoped>
.ar-container {
  display: block;
  overflow: hidden;
  position: relative;
  width: 100%;
  min-height: 40px;
  height: 100%;
  height: min(200px, 100%);

  .ar-inner {
    display: block;
    width: 100%;
    max-height: 100%;
  }

  .ar-limit {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
  }
}
</style>
